import React, { useEffect, useState, useContext } from "react";

import { AuthContext } from "../context/AuthContext";
import DataTable from 'react-data-table-component';

import { getPaginatedReleases } from "../controllers/releaseController";
import { useNavigate } from "react-router-dom";

const Releases = () => {
  // const { user, setUser } = useContext(AuthContext);

  const [searchText, setSearchText] = useState("");
  const [state, setState] = useState({
    releases: [],
    offset: 0,
    perPage: 10,
    page: 1,
    total: 0,
    sortBy: '',
    sortOrder: '',
    q: '',
    loading: false,
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSearch = (e) => {

    setState(prev => ({
      ...prev,
      q: searchText,
      offset: 0,
      page: 1,
      loading: true
    }));
  };


  useEffect(() => {
    getPaginatedReleases(state, setState, setLoading);
  }, [state.offset, state.page, state.perPage, state.sortOrder, state.q]);

  const columns = [
    {
      name: 'S.No',
      cell: (row, index) => state.offset + index + 1,
      width: '80px',
    },
    {
      name: 'Name',
      selector: row => row.display_name,
      sortable: true,
    },
    {
      name: 'Issued Date',
      selector: row => row.issued_date,
      sortable: true,
    },
    {
      name: 'Type',
      selector: row => row.type,
    },
    {
      name: 'Space Used',
      selector: row => row.release_file_size,
    },
    {
      name: 'Cover',
      cell: row => (
        <img
          src={`https://dittmagasin.no/resources/uploads/releases/images/${row.image}`}
          alt={row.display_name}
          style={{ width: 80 }}
        />
      ),
    },
    {
      name: 'Actions',
      cell: row => (
        <div className="d-flex gap-1">
          <button
            className="btn btn-sm btn-info"
            onClick={() => navigate(`/releases/${row.id}`)}
          >
            View
          </button>
          <button
            className="btn btn-sm btn-warning"
            onClick={() => navigate(`/releases/${row.id}/edit`)}
          >
            Edit
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    }
  ];


  // const [loading, setLoading] = useState(true);

  const goToPage = (page) => {
    if (page >= 1 && page <= state.totalPages) {
      setState(prev => ({ ...prev, currentPage: page, page: page }));
    }
  };

  return (
    <div className="container">
      <input
        type="text"
        placeholder="Search..."
        onChange={(e) => setSearchText(e.target.value)}
        value={searchText}
        name="q"
        onBlur={() => {
          setState(prev => ({ ...prev, q: searchText, page: 1 })); // sync on blur
          handleSearch(searchText);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            setState(prev => ({ ...prev, q: searchText, page: 1 }));
            handleSearch(searchText);
          }
        }}
        onMouseLeave={() => {
          setState(prev => ({ ...prev, q: searchText, page: 1 }));
          handleSearch(searchText);
        }}
      />
      <div className="card">
        <div className="card-body">
          <DataTable
            columns={columns}
            data={state.releases}
            pagination
            paginationServer
            paginationTotalRows={state.total}
            paginationPerPage={state.perPage}
            onChangePage={(page) => {
              const newOffset = (page - 1) * state.perPage;
              setState(prev => ({ ...prev, offset: newOffset, page: page }));
            }}
            onSort={(column, sortDirection) => {
              setState(prev => ({
                ...prev,
                sortBy: column.selector || column.name,
                sortOrder: sortDirection,
                offset: 0,
                page: 1
              }));
            }}
            progressPending={loading}
            progressComponent={<div className="p-3 text-center">Loading releases...</div>}
            noDataComponent={<div className="p-3 text-center">No releases found</div>}
            sortServer
          />
        </div>
      </div>
    </div>
  );
};

export default Releases;
